import { ModalId } from '@heidi/schema/ml-scribe';

import {
  MODAL_PRIORITY,
  type QueuedModalDescriptor,
} from '../../../../dictation-modal-queue-ports';

export const DICTATION_LOGS_SPOTLIGHT_MODAL_ID = ModalId.DICTATION_LOGS_SPOTLIGHT;

/** Enqueued from dictate-onboarding complete (user-triggered; bypasses pacing). */
export const DICTATION_LOGS_SPOTLIGHT_QUEUE_ITEM: QueuedModalDescriptor = {
  id: DICTATION_LOGS_SPOTLIGHT_MODAL_ID,
  priority: MODAL_PRIORITY.HIGH,
  dismissible: true,
  showOnce: true,
};
